import { fromJS } from 'immutable';
import { get } from 'lodash';
import {
  SET_LISTINGS,
  SET_KECLOAK_TOKEN,
  SET_LAWYER_NOTIFICATIONS,
  SET_MANAGER_NOTIFICATIONS,
  SET_CURRENT_INSTANCE_TAB,
  SET_LISTINGS_INTERVENANTS,
  SET_LINK_BENEFICIARY_CODES,
  SET_EXPERT_NOTIFICATIONS,
  SET_NOTIFICATION_OPENING_MANAGER_MIXED_CLAIM,
  SET_CLAIM_NUMBER,
  SET_NOTIFICATION,
  SET_OPEN_UNLOCK_CLAIM_DIALOG,
  SET_CURRENT_INDEX_TAB_MANAGER,
  SET_CURRENT_INDEX_TAB_JUDICIARY_PROCESS_MANAGER,
  SET_CURRENT_INDEX_GLOBAL_TAB_MANAGER,
  SET_NOTIFICATION_FEE_NOTE,
  SET_NOTIFICATIONS_INBOXES,
  SET_CURRENT_INDEX_TAB_EXPERTISE,
  REQUEST_SET_COUNT_NOTIFICATIONS_MANAGER,
  RESET_INDEX_TABS,
  SET_CURRENT_INDEX_TAB_TRANSACTION,
  SET_TRANSACTION_ID,
  SET_CURRENT_REGULATION_PATH,
  SET_INBOXES_LAWYER_NOTIFICATIONS,
  SET_COUNT_INBOXES_LAWYER_NOTIFICATIONS,
  SET_CURRENT_INDEX_GLOBAL_TAB_LAWYER,
  SET_CURRENT_INDEX_TAB_JUDICIARY_PROCESS_LAWYER,
  SET_CURRENT_INDEX_TAB_LAWYER,
} from 'containers/AppContainer/constants';
import { Listings, ListingSetAction } from 'containers/AppContainer/typings';
import { RESET_STORE } from 'containers/LoginPage/constants';

export interface AppContainerAction {
  type: string;
  listings?: Listings;
  token?: string;
  lawyerNotifications?: any;
  managerNotifications?: any;
  index?: string;
  expertNotifications?: any;
  openingManagerNotificationsMixedClaim?: any;
  claim: any;
  claimNumber: string;
  openUnlockClaim: null;
  currentTabManager: null;
  currentTabJudiciaryProcessManager: null;
  currentGlobalTabIndexManager: null;
  feeNote: null;
  notificationsInboxes: null;
  countNotificationsManagers: null;
  countInboxesManagers: null;
  currentTabIndexExpertise: null;
  currentTabIndexTransaction: null;
  transactionId: null;
  currentRegulationPath: any;
  inboxesLawyerNotifications: any;
  countInboxesLawyerNotifications: any;
  currentGlobalTabIndexLawyer: any;
  currentTabJudiciaryProcessLawyer: any;
  currentTabLawyer: any;
}

const initialState: any = fromJS({
  listings: {},
  keycloakToken: null,
  lawyerNotifications: [],
  managerNotifications: [],
  currentTabInstance: null,
  intervenants: [],
  linkToBeneficiaryCodes: [],
  expertNotifications: [],
  openingManagerNotificationsMixedClaim: [],
  claim: {},
  claimNumber: null,
  notification: {},
  openUnlockClaimDialog: false,
  currentTabManager: null,
  currentTabJudiciaryProcessManager: null,
  currentGlobalTabIndexManager: null,
  feeNote: {},
  notificationsInboxes: [],
  countNotificationsManagers: null,
  countInboxesManagers: null,
  currentTabIndexExpertise: null,
  currentTabIndexTransaction: null,
  transactionId: null,
  currentRegulationPath: {},
  inboxesLawyerNotifications: [],
  countInboxesLawyerNotifications: null,
  currentGlobalTabIndexLawyer: null,
  currentTabJudiciaryProcessLawyer: null,
  currentTabLawyer: null,
});

const appContainerReducer = (
  state = initialState,
  action: ListingSetAction,
) => {
  switch (action.type) {
    case SET_LISTINGS_INTERVENANTS:
      return state.set(
        'intervenants',
        fromJS(get(action, ['intervenants', 'data'])),
      );
    case SET_LISTINGS:
      return state.set(
        'listings',
        fromJS(get(action, ['listings', 'data', 'listings'])),
      );
    case SET_LINK_BENEFICIARY_CODES:
      return state.set(
        'linkToBeneficiaryCodes',
        fromJS(get(action, ['linkToBeneficiaryCodes', 'data'])),
      );
    case SET_LAWYER_NOTIFICATIONS:
      return state.set(
        'lawyerNotifications',
        fromJS(action.lawyerNotifications),
      );
    case SET_MANAGER_NOTIFICATIONS:
      return state
        .set(
          'managerNotifications',
          fromJS([
            ...state.get('managerNotifications').toJS(),
            ...action.managerNotifications.managerNotifications,
          ]),
        )
        .set(
          'countNotificationsManagers',
          fromJS(action.managerNotifications.count),
        );
    case RESET_STORE:
      return initialState;
    case SET_KECLOAK_TOKEN: {
      return state.set('keycloakToken', fromJS(action.token));
    }
    case SET_CURRENT_INSTANCE_TAB:
      return state.set('currentTabInstance', fromJS(action.index));
    case SET_EXPERT_NOTIFICATIONS:
      return state.set(
        'expertNotifications',
        fromJS(action.expertNotifications),
      );
    case SET_NOTIFICATION_OPENING_MANAGER_MIXED_CLAIM:
      return state.set(
        'openingManagerNotificationsMixedClaim',
        fromJS(action.mixedClaims),
      );
    case SET_CLAIM_NUMBER:
      return state.set('claimNumber', fromJS(action.payload));
    case SET_NOTIFICATION:
      return state.set('notification', fromJS(action.payload));
    case SET_OPEN_UNLOCK_CLAIM_DIALOG:
      return state.set('openUnlockClaimDialog', fromJS(action.payload));
    case SET_CURRENT_INDEX_TAB_MANAGER:
      return state.set('currentTabManager', fromJS(action.payload));
    case SET_CURRENT_INDEX_TAB_JUDICIARY_PROCESS_MANAGER:
      return state.set(
        'currentTabJudiciaryProcessManager',
        fromJS(action.payload),
      );
    case SET_CURRENT_INDEX_GLOBAL_TAB_MANAGER:
      return state.set('currentGlobalTabIndexManager', fromJS(action.payload));
    case SET_NOTIFICATION_FEE_NOTE:
      return state.set('feeNote', fromJS(action.payload));
    case SET_NOTIFICATIONS_INBOXES:
      return state.set(
        'notificationsInboxes',
        fromJS(action.payload.managerNotifications),
      );
    case REQUEST_SET_COUNT_NOTIFICATIONS_MANAGER:
      return state.set('countInboxesManagers', fromJS(action.payload.count));
    case SET_CURRENT_INDEX_TAB_EXPERTISE:
      return state.set('currentTabIndexExpertise', fromJS(action.payload));
    case SET_CURRENT_INDEX_TAB_TRANSACTION:
      return state.set('currentTabIndexTransaction', fromJS(action.payload));
    case SET_TRANSACTION_ID:
      return state.set('transactionId', fromJS(action.payload));
    case SET_CURRENT_REGULATION_PATH:
      return state.set('currentRegulationPath', fromJS(action.payload));
    case RESET_INDEX_TABS:
      return state
        .set('currentTabManager', fromJS(null))
        .set('currentTabJudiciaryProcessManager', fromJS(null))
        .set('currentGlobalTabIndexManager', fromJS(null))
        .set('currentTabIndexExpertise', fromJS(null))
        .set('currentTabInstance', fromJS(null))
        .set('currentTabIndexTransaction', fromJS(null))
        .set('currentRegulationPath', fromJS({}));
    case SET_INBOXES_LAWYER_NOTIFICATIONS:
      return state.set(
        'inboxesLawyerNotifications',
        fromJS(action.inboxesLawyerNotifications),
      );
    case SET_COUNT_INBOXES_LAWYER_NOTIFICATIONS:
      return state.set(
        'countInboxesLawyerNotifications',
        fromJS(
          action.countInboxesLawyerNotifications
            .countInboxesLawyerNotifications,
        ),
      );
    case SET_CURRENT_INDEX_GLOBAL_TAB_LAWYER:
      return state.set('currentGlobalTabIndexLawyer', fromJS(action.payload));
    case SET_CURRENT_INDEX_TAB_JUDICIARY_PROCESS_LAWYER:
      return state.set(
        'currentTabJudiciaryProcessLawyer',
        fromJS(action.payload),
      );
    case SET_CURRENT_INDEX_TAB_LAWYER:
      return state.set('currentTabLawyer', fromJS(action.payload));

    default:
      return state;
  }
};

export default appContainerReducer;
